export default __webpack_public_path__ + "static/media/monitor-system.c3ef786a.svg";